import { render, staticRenderFns } from "./CommonList.vue?vue&type=template&id=087d67c6&scoped=true&"
import script from "./CommonList.vue?vue&type=script&lang=js&"
export * from "./CommonList.vue?vue&type=script&lang=js&"
import style0 from "./CommonList.vue?vue&type=style&index=0&id=087d67c6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.9.6_kq6vcxhoovkpo5ecbydii27d4a/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "087d67c6",
  null
  
)

export default component.exports